import type {
  AnchorHTMLAttributes,
  DetailedHTMLProps,
  FC,
  MouseEvent,
  PropsWithChildren,
} from 'react';
import { Container } from './style';

export type FillButtonProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  disabled?: boolean;
};

const FillButton: FC<PropsWithChildren<FillButtonProps>> = ({
  children,
  disabled,
  onClick,
  ...props
}) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };
  return (
    <Container onClick={handleClick} disabled={disabled} {...props}>
      {children}
    </Container>
  );
};

export default FillButton;
